export default __webpack_public_path__ + "static/media/cancel.92108b85.svg";